// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-profile-1 {
  width: 60%;
}

.section-profile-1 .box-profile {
  background-color: #fff;
  width: 100%;
  padding: 1rem;
  border-top: 3px solid #327a6d;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.section-profile-1 .box-profile .profile-text-content {
  padding: 1.2rem;
}

.profile-section-container {
  width: 60%;
}

.profile-section-container .box-profile-1,
.box-profile-2 {
  background-color: #fff;
  width: 100%;
  padding: 1rem;
  border-top: 3px solid #327a6d;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.section-profile-3 {
  width: 60%;
}
.section-profile-3 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.section-profile-3 p {
  font-size: 1.2rem;
}

.modal {
  display: none;
  position: fixed;
  z-index: 9999999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 1650px) {
  html {
    font-size: 85%;
  }
  .section-profile-1 {
    width: 60%;
  }

  .profile-section-container {
    width: 75%;
  }
  .section-profile-3 {
    width: 80%;
  }
}

@media (min-width: 600px) and (max-width: 1080px) {
}

@media (max-width: 580px) {
  html {
    font-size: 85%;
  }
  .section-profile-1 .box-profile .profile-text-content {
    overflow-y: scroll;
    height: 350px;
  }
  .profile-section-container h1 {
    text-align: center;
  }
  .profile-section-container p {
    text-align: center;
  }
  .profile-section-container .box-profile-2 {
    height: 350px;
    overflow: none;
  }
  .profile-section-container .box-profile-2 .profile-ol-container {
    overflow-y: scroll;
    padding: 0.8rem;
  }
  .section-profile-3 h1,
  p {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/profile.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;AACA;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".section-profile-1 {\r\n  width: 60%;\r\n}\r\n\r\n.section-profile-1 .box-profile {\r\n  background-color: #fff;\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border-top: 3px solid #327a6d;\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n}\r\n\r\n.section-profile-1 .box-profile .profile-text-content {\r\n  padding: 1.2rem;\r\n}\r\n\r\n.profile-section-container {\r\n  width: 60%;\r\n}\r\n\r\n.profile-section-container .box-profile-1,\r\n.box-profile-2 {\r\n  background-color: #fff;\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border-top: 3px solid #327a6d;\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n}\r\n\r\n.section-profile-3 {\r\n  width: 60%;\r\n}\r\n.section-profile-3 img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n.section-profile-3 p {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.modal {\r\n  display: none;\r\n  position: fixed;\r\n  z-index: 9999999;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.modal-content {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  max-width: 90%;\r\n  max-height: 90%;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  animation: fadeIn 0.3s;\r\n}\r\n\r\n.close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 20px;\r\n  color: #fff;\r\n  font-size: 40px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@media (max-width: 1650px) {\r\n  html {\r\n    font-size: 85%;\r\n  }\r\n  .section-profile-1 {\r\n    width: 60%;\r\n  }\r\n\r\n  .profile-section-container {\r\n    width: 75%;\r\n  }\r\n  .section-profile-3 {\r\n    width: 80%;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  html {\r\n    font-size: 85%;\r\n  }\r\n  .section-profile-1 .box-profile .profile-text-content {\r\n    overflow-y: scroll;\r\n    height: 350px;\r\n  }\r\n  .profile-section-container h1 {\r\n    text-align: center;\r\n  }\r\n  .profile-section-container p {\r\n    text-align: center;\r\n  }\r\n  .profile-section-container .box-profile-2 {\r\n    height: 350px;\r\n    overflow: none;\r\n  }\r\n  .profile-section-container .box-profile-2 .profile-ol-container {\r\n    overflow-y: scroll;\r\n    padding: 0.8rem;\r\n  }\r\n  .section-profile-3 h1,\r\n  p {\r\n    text-align: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
